@if (award) {
  <div *transloco="let t" class="mt-2 inline-flex items-center rounded-full py-1 pr-2 print:mt-0">
    <div class="mr-2 flex h-7 w-7 justify-center rounded-full border-2 border-white" [style.background]="awardConfig?.color">
      <rma-icon class="rma-icon-award-sm" glyph="rma-award" />
    </div>
    <!-- SHOULD MOVE OUT OF LOCATIONS -->
    @let actor = t('agent', { count: 1 }) | titlecase;
    {{
      t('locations.award.' + (award.awardType | lowercase), {
        location: award.awardName,
        ranking: award.ranking,
        actor: actor,
      })
    }}
  </div>
}
